<template>
  <div>
    <ejs-treeview id='moTree'
      ref="moTree"
      :fields='fields'
      @nodeSelected="moTreeSelected">
    </ejs-treeview>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import packageParams from '@/components/mmlconfig/mixins/packageParams';
import bus from '../bus.js';

const { mapGetters } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'mo-global-tree',
  data() {
    return {
    };
  },
  props: {
    fields: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mixins: [packageParams],
  created() {
  },
  computed: {
    ...mapGetters(['currentNode']),
  },
  methods: {
    quickSort() {
    },
    refreshTree() {
    },
    moTreeSelected(args) {
      console.log('---------moTreeSelected-----------');
      const moDataArr = this.$refs.moTree.getTreeData(args.node);
      console.log(moDataArr);
      const moData = moDataArr[0];
      bus.$emit('refreshAndLoadTabsGlobal', moData);
      // 查询分支参数 并缓存于LocalStorage中
      // const key = `${this.currentNode.typeCode}_${this.currentNode.softwareVersion}`;
      // let moBranchCache = JSON.parse(localStorage.getItem(key));
      // if (moBranchCache == null) {
      //   moBranchCache = {};
      // }
      // if (moBranchCache[`${moData.moName}_branch`] == null) {
      //   const params = this.packageMoBranchParams(this.currentNode, moData);
      //   this.$loading.showLoadding(this.$t('MML.loadingTip'));
      //   this.axios.post('/lte/ems/config/mml/getMoBranchLst', params).then(res => {
      //     const moBranchRes = res.data.resultVal;
      //     if (moBranchRes && moBranchRes.reactAttr) {
      //       const branchLst = moBranchRes.reactAttr.RspAttrList;
      //       moData.branch = JSON.parse(branchLst);
      //       moBranchCache[`${moData.moName}_branch`] = branchLst;
      //       localStorage.setItem(key, JSON.stringify(moBranchCache));
      //     }
      //     this.$loading.hideLoadding();
      //     bus.$emit('refreshAndLoadTabs', moData);
      //   }).catch(err => {
      //     this.$loading.hideLoadding();
      //   });
      // } else {
      //   const branchLst = moBranchCache[`${moData.moName}_branch`];
      //   moData.branch = JSON.parse(branchLst);
      //   bus.$emit('refreshAndLoadTabs', moData);
      // }
    }
  }
};
</script>
<style>
</style>
